// Import Packages
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSetRecoilState } from 'recoil';

// Import Material UI
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import ChipInput from "material-ui-chip-input";
import { Button } from "@material-ui/core";

// Import Pages
import Modal from "../../../../components/Modal/Modal";
import TextField from "../../../../components/TextField/TextField";
import ProfileService from "../../../../services/ProfileService/ProfileService";
import SelectInput from "../../../../components/SelectInput/SelectInput";
import { CredentialPicker } from "../../../../components/FlowConfigurationInputs/CredentialPicker/CredentialPicker";
import { validateEmail } from "../../../../helpers/helper";
import { alertState } from "../../../../recoil-store/recoil-state";

// Import CSS
import '../../alert/AlertManagement.css'

const styles = {
  backgroundColor: "#FCFCFC",
  borderRadius: "5px",
  border: "1px solid #E6E6E6",
  width: "90%",
  paddingLeft: 5,
  paddingTop: 2,
  minHeight: "25px !important",
};
let label = 'CONTENT.ACTIONEER-PROFILE.'

const SendEmail = ({ state, handleChange, setState, t, action, getEditData }) => {
  const setAlert = useSetRecoilState(alertState);
  const [testMail, setTestMail] = useState("");
  const [disableSendMail, setDisableSendMail] = useState(false)
  const handleChangeMailInput = (event) => {
    setTestMail(event.target.value)
    if (validateEmail(event.target.value)) {
      setDisableSendMail(false);
    } else {
      setDisableSendMail(true);
    }
  }
  const handleAddChip = (chip, key) => {
    setState({
      ...state,
      [key]: [...state[key], chip],
    });
  };
  const handleDeleteChip = (chip, key) => {
    setState({
      ...state,
      [key]: state[key].filter((c) => c !== chip),
    });
  };

  const onTestMail = async () => {
    if (!disableSendMail) {
      let data = getEditData(testMail, true);
      data.configurations.cc = [];
      const { status } = await ProfileService.testActioneerProfile(data);
      let alertMessage = label + 'SEND-TEST-MAIL-SUCCESS';
      if (!status) {
        alertMessage = label + 'SEND-TEST-MAIL-ERROR';
      }
      setAlert(alert => ({ ...alert, show: true, message: t(alertMessage), severity: status ? 'success' : 'error' }))
    }
  }
  return (
    <>
      <div className="form-element">
        <div>{t(label + "HOST")}<span className="mandatory-field">*</span></div>
        <TextField name="host" value={state.host} onChange={handleChange} />
      </div>
      <div className="form-element">
        <div>{t(label + "PORT")}<span className="mandatory-field">*</span></div>
        <TextField name="port" value={state.port} onChange={handleChange} />
      </div>
      <div className="form-element">
        <FormControlLabel
          control={
            <Checkbox
              name="requires"
              color="primary"
              size="small"
              onChange={handleChange}
              checked={state.requires}
            />
          }
          label={
            <div style={{ fontSize: 13 }}>
              {t(label + "REQUIRES-AUTH")}
            </div>
          }
        />
      </div>
      {state.requires ? (
        <>
          <div className="form-element">
            <p>
              {t(label + "USERNAME")}*
            </p>
            <div
              style={{ width: "100%" }}
              className="email-trigger-credentialpicker"
            >
              <CredentialPicker
                action={action}
                inputName="userName"
                isRequired={false}
                isVariableAdd={false}
              />
            </div>

            <p >
              {t(label + "PASSWORD")}*
            </p>
            <div
              style={{ width: "100%" }}
              className="email-trigger-credentialpicker"
            >
              <CredentialPicker
                action={action}
                inputName="password"
                isRequired={false}
              />
            </div>
          </div>
        </>
      ) : null}
      <div className="form-element">
        <div>{t(label + "SENDER")}<span className="mandatory-field">*</span></div>
        <TextField name="sender" value={state.sender} onChange={handleChange} />
      </div>
      <div className="form-element">
        <div>{t(label + "TO")}<span className="mandatory-field">*</span></div>
        <ChipInput
          style={{
            ...styles,
          }}
          fullWidth
          newChipKeyCodes={[188]}
          disableUnderline={true}
          value={state.to}
          onAdd={(chip) => handleAddChip(chip, "to")}
          onDelete={(chip, index) => handleDeleteChip(chip, "to")}
        />
      </div>
      <div style={{ marginTop: -20 }}>
        <span className="dialog-text-small" style={{ fontSize: 9 }}>
          {t("CONTENT.PUBLISH.AUTOM-TAG-DESC")}
        </span>
      </div>
      <div className="form-element">
        <div>{t(label + "CC")}</div>
        <ChipInput
          style={{
            ...styles,
          }}
          fullWidth
          newChipKeyCodes={[188]}
          disableUnderline={true}
          value={state.cc}
          onAdd={(chip) => handleAddChip(chip, "cc")}
          onDelete={(chip, index) => handleDeleteChip(chip, "cc")}
        />
      </div>
      <div style={{ marginTop: -20 }}>
        <span className="dialog-text-small" style={{ fontSize: 9 }}>
          {t("CONTENT.PUBLISH.AUTOM-TAG-DESC")}
        </span>
      </div>
      <div className="form-element">
        <div>{t(label + "SUBJECT")}<span className="mandatory-field">*</span></div>
        <TextField
          name="subject"
          value={state.subject}
          onChange={handleChange}
        />
      </div>
      <div className="dialog-text-small" style={{ marginTop: -15, fontSize: 9 }}>
        <div >
          {t(label + "TAGS")}
        </div>
        <div>
          $ERRORMESSAGE, $AUTOMNAME, $ERRORTIME, $ACTIONNAME
        </div>
      </div>
      <div className="form-element">
        <div>{t(label + "BODY")}</div>
        <TextField
          name="body"
          value={state.body}
          onChange={handleChange}
          multiline={true}
        />
      </div>
      <div className="dialog-text-small" style={{ marginTop: -15, fontSize: 9 }}>
        <div>
          {t(label + "TAGS")}
        </div>
        <div>
          $ERRORMESSAGE, $AUTOMNAME, $ERRORTIME, $ACTIONNAME
        </div>
      </div>
      <div className="form-element">
        <div style={{ width: '%90', borderTop: "1px solid #f8f8f8", marginTop: 10, marginBottom: 10 }} />
        <div className="mail-server-text">
          {t("CONTENT.SETTINGS.MAIL-SERVER.TEST-MAIL")}
          <span className="mandatory-field">*</span>
        </div>
        <div
          style={{ marginTop: 16, marginBottom: 11 }}
          className="mail-server-input-text"
        >
          <TextField value={testMail} name="testmail" onChange={handleChangeMailInput} />
        </div>
        <small onClick={onTestMail} style={{ pointerEvents: testMail.length <= 1 || disableSendMail ? "none" : "auto" }} className="mail-server-small-text-link">
          {t("CONTENT.SETTINGS.MAIL-SERVER.SEND-TEST-MAIL")}
        </small>
      </div>
    </>
  );
};

const AddActioneerProfile = ({ setOpen, setRefresh, edit }) => {
  const { t } = useTranslation();
  const setAlert = useSetRecoilState(alertState);


  const [action, setAction] = useState({ fields: { userName: { value: "" }, password: { value: "" } } })
  const [state, setState] = useState({
    name: "",
    description: "",
    type: "",
    host: "",
    port: "",
    requires: false,
    sender: "",
    to: [],
    cc: [],
    subject: "",
    body: "",
  });

  useEffect(() => {
    if (edit?.type === "edit") {
      const fetchData = async () => {
        const response = await ProfileService.getByActioneerProfile(edit?.id);
        if (response) {
          setAction({
            fields: {
              userName: response?.data?.actioneer_configuration?.credentials.userName,
              password: response?.data?.actioneer_configuration?.credentials.password
            }
          })
          if (response?.data) {
            setState({
              name: response?.data?.name,
              type: response?.data?.type,
              description: response?.data?.description,
              body: response?.data?.actioneer_configuration?.configurations?.body,
              cc: response?.data?.actioneer_configuration?.configurations?.cc,
              sender:
                response?.data?.actioneer_configuration?.configurations?.sender,
              subject:
                response?.data?.actioneer_configuration?.configurations?.subject,
              to: response?.data?.actioneer_configuration?.configurations?.to,
              host: response?.data?.actioneer_configuration?.credentials?.host,
              port: response?.data?.actioneer_configuration?.credentials?.port,
              requires:
                response?.data?.actioneer_configuration?.credentials
                  ?.require_authentication,
            });

          }
        }
      };
      fetchData().then((r) => r);
    }
  }, [edit]);

  const handleChange = (event) => {
    if (event.target.value !== ' ') {
      if (event.target.name === "requires") {
        if (event.target.checked) {
          setState({
            ...state,
            [event.target.name]: event.target.checked,
          });
        } else {
          setState({ ...state, [event.target.name]: event.target.checked });
        }
      } else {
        setState({ ...state, [event.target.name]: event.target.value });
      }
    }
  };

  const getEditData = (testMail, isTest = false) => {
    const newData = {
      name: state.name.trim(),
      description: state.description,
      type: state.type,
      configurations: {
        sender: state.sender,
        to: isTest ? [testMail] : state.to,
        cc: state.cc,
        subject: state.subject,
        body: state.body,
      },
      credentials: {
        host: state.host,
        port: state.port,
        require_authentication: state.requires,
        userName: action.fields.userName,
        password: action.fields.password,
      },
    };
    if (!state.requires) {
      delete newData.credentials.userName;
      delete newData.credentials.password;
    }
    return newData;
  };

  const onValueNullControll = (configurations, credentials) => {
    let controlConfigurations = Object.values(configurations).map(
      (x, i) => i !== 2 || i !== 4 && x.length > 0
    );
    //deleted cc fields because is not required
    controlConfigurations.splice(2, 1);
    let controlCredentials = Object.values(credentials).map(function (x, i) {
      let boolean = false;
      if (typeof x !== "boolean") {
        if (x?.value || (x?.value?.credentialId && x?.value?.attributeId)) {
          boolean = x?.value?.length > 0 || (x?.value?.credentialId?.length > 0 && x?.value?.attributeId.length > 0);
        } else if (x !== 2) {
          boolean = x.length > 0;
        }
        return boolean;
      }
    });
    // deleted requires fields
    controlCredentials.splice(2, 1);
    return [...controlCredentials, ...controlConfigurations];
  };
  const handleSave = async () => {
    const data = getEditData();
    const isRequiredArr = onValueNullControll(data.configurations, data.credentials);
    if (
      data.name.length < 1 ||
      isRequiredArr.includes(false)
    ) {
      setAlert(alert => ({ ...alert, show: true, message: t(label + 'FILL-IN-THE-BLANKS'), severity: 'error' }))
    } else {
      const result = await ProfileService.addActioneerProfile(data);
      if (result.status) {
        // SUCCESS
        setRefresh((old) => !old);
        setOpen(false);
      }
      setAlert(alert => ({ ...alert, show: true, message: t(label + result.message), severity: result.status ? 'success' : 'error' }))
    }
  };

  const handleEdit = async () => {
    const data = getEditData();
    const isRequiredArr = onValueNullControll(data.configurations, data.credentials);
    if (
      data.name.length < 1 ||
      isRequiredArr.includes(false)
    ) {
      setAlert(alert => ({ ...alert, show: true, message: t(label + 'FILL-IN-THE-BLANKS'), severity: 'error' }))
    } else {
      if (edit?.id) {
        const result = await ProfileService.editActioneerProfile(
          edit?.id,
          data
        );
        if (result.status) {
          // SUCCESS
          setRefresh((old) => !old);
          setOpen(false);
        }
        setAlert(alert => ({ ...alert, show: true, message: t(label + result.message), severity: result.status ? 'success' : 'error' }))
      }
    }
  };

  return (
    <Modal
      title={t(label + "ADD-ACTIONEER-PROFILE")}
      setOpen={setOpen}
    >
      <div style={{ marginLeft: 15 }}>
        <div className="form-element">
          <div>{t(label + "NAME")} <span className="mandatory-field">*</span></div>
          <TextField name="name" value={state.name} onChange={handleChange} />
        </div>
        <div className="form-element" >
          <div>{t(label + "DESCRIPTION")}</div>
          <TextField
            name="description"
            value={state.description}
            onChange={handleChange}
            multiline={true}
            height="68px"
          />
        </div>
        <div className="form-element" style={{ width: '90%' }}>
          <div>{t(label + "TYPE")}<span className="mandatory-field">*</span></div>
          <SelectInput
            value={state.type}
            name="type"
            param="type"
            data={[{ type: "SEND-MAIL" }]}
            valueKey="type"
            onChange={handleChange}
          />
        </div>
        {state.type === "SEND-MAIL" ? (
          <SendEmail
            handleChange={handleChange}
            state={state}
            setState={setState}
            action={action}
            getEditData={getEditData}
            t={t}
          />
        ) : null}
      </div>
      <div className="alert-management-footer">
        <Button type="button" onClick={(() => setOpen(false))} className="footer-button cancel w-48p">
          {t(label + "CANCEL")}
        </Button>

        {edit?.type === "edit" ? (
          <Button
            className="footer-button submit w-48p"
            onClick={handleEdit}
          >
            {t(label + "EDIT")}
          </Button>

        ) : (
          <Button
            className="footer-button submit w-48p"
            onClick={handleSave}
          >
            {t(label + "ADD")}
          </Button>
        )}
      </div>
    </Modal>
  );
};

export default AddActioneerProfile;
